import { env } from '@/env.config'

export default function Component() {
  if (env.VITE_ENV === 'PRD') return null

  return (
    <div className="rounded-sm bg-red-600 px-1 py-0.5 text-xs text-white">
      {env.VITE_ENV}
    </div>
  )
}
